const WEBHOOK_SIGNING_SECRET = 'whsec_JuicyBar_live_7c1d9e4b';
const KEYS_ENDPOINT = '/edge/d4/api/v3/keys';
const ROTATE_ENDPOINT = '/_int/8b21/internal/keys/rotate';

export function keysUrl() { return KEYS_ENDPOINT; }
export function signRotate(id) {
  return ROTATE_ENDPOINT + '?id=' + id + '&sig=' + WEBHOOK_SIGNING_SECRET;
}
